import type { I18nDict } from '../types.ts'

export const da: I18nDict = {
  app_name: 'ZION',
  settings_title: 'Indstillinger',
  section_language: 'Sprog',
  section_identity: 'Lokal identitet',
  section_updates: 'App-opdatering',
  section_notifications: 'Notifikationer',
  section_theme: 'Visuelt tema',
  section_backup: 'Chat-sikkerhedskopi',
  section_privacy_network: 'Netværksfortrolighed',
  section_media: 'Multimedia',
  section_security: 'Sikkerhed og adgangskode',
  section_exit: 'Luk og slet data',
  toggle_external_links: 'Modtag og vis eksterne links',
  hint_external_links: 'Hvis FRA: ingen link-forhåndsvisninger i chatten, og eksterne URL\'er kan ikke åbnes (beskyttelse mod IP-sporing).',
  toggle_auto_media: 'Automatisk download af medier og dokumenter',
  hint_auto_media: 'Hvis FRA: billeder, videoer og filer downloades ikke i baggrunden — tryk manuelt i chatten.',
  toggle_require_unlock: 'Adgangskode ved app-åbning',
  hint_require_unlock: 'Når TIL, kræves hovedadgangskoden hver gang du åbner ZION.',
  toggle_wipe_exit: 'Slet data ved afslutning',
  hint_wipe_exit: 'Når TIL, ryddes midlertidig RAM-cache og sessionsdata, når appen lukkes.',
  btn_exit: 'Afslut',
  btn_delete_all: 'SLET AL DATA',
  btn_lock: 'Lås app',
  btn_back: 'Tilbage',
  warn_disable_password_title: '⚠️ ADVARSEL',
  warn_disable_password_body: 'At deaktivere åbningsadgangskoden betyder, at alle med adgang til din enhed kan læse dine krypterede beskeder. Er du sikker på, at du vil fortsætte?',
  warn_delete_all_1: 'Vil du virkelig ødelægge hele databasen? Denne handling kan ikke fortrydes.',
  warn_delete_all_2: 'Endelig bekræftelse: alle chats, private nøgler og indstillinger slettes permanent.',
  link_blocked: 'Eksternt link blokeret (privatlivsindstillinger).',
  lang_welcome_title: 'Velkommen til ZION',
  lang_welcome_sub: 'Vælg dit sprog',
  lang_continue: 'Fortsæt',
  settings_language_label: 'App-sprog',
  auth_unlock_title: 'Lås op',
  auth_or_password: '— eller lås op med adgangskode —',
  auth_password_master: 'Hovedadgangskode',
  auth_unlock_btn: 'Lås op',
  auth_verifying: 'Verificerer…',
  auth_wrong_password: 'Forkert adgangskode',
  auth_unlocked: 'Låst op ✓',
  auth_access_title: 'Deltag i ZION',
  auth_beta_spots: 'Gratis beta · pladser tilbage:',
  auth_beta_full: 'Beta fuld ({max} brugere). Prøv igen senere.',
  auth_beta_free: 'Gratis beta · ingen licens påkrævet',
  auth_or_create: '— eller opret en ny identitet —',
  auth_password_min: 'Adgangskode (min. 8 tegn)',
  auth_password_confirm: 'Bekræft adgangskode',
  auth_privacy_check: 'Jeg har læst',
  auth_privacy_link: 'Privatlivspolitikken',
  auth_terms_check: 'Jeg accepterer',
  auth_terms_link: 'Servicevilkårene',
  auth_password_local_hint: 'Adgangskoden forlader aldrig denne enhed. Ingen serverkonto.',
  auth_create_identity: 'Opret identitet',
  auth_accept_legal_err: 'Accepter privatliv og vilkår for at fortsætte',
  auth_generating_keys: 'Genererer nøgler og session…',
  auth_generating_identity: 'Genererer anonym identitet…',
  auth_generating_detail: 'ECDH-nøgler · kaldenavn · socket-session · ZN- kode',
  auth_you_are: 'Du er',
  auth_daily_suffix_hint: 'Det daglige suffiks ændres hver UTC-dag. For at parre, brug ZN- koden på Hjem.',
  auth_enter: 'Gå ind i ZION',
  auth_starting: 'Starter…',
  auth_restore_title: 'Gendan sikkerhedskopi',
  auth_restore_hint: 'Har du allerede en krypteret sikkerhedskopi? Gendan identitet, kontakter og chats (f.eks. efter at have ryddet cache).',
  auth_restore_file: 'Sikkerhedskopifil (.enc / .enc.json)',
  auth_restore_pass: 'Adgangssætning til sikkerhedskopi',
  auth_restore_pass_ph: 'Adgangssætning brugt ved eksport',
  auth_restore_btn: 'Gendan sikkerhedskopi',
  auth_restore_pick_file: 'Vælg en sikkerhedskopifil (.enc eller .enc.json).',
  auth_restore_need_pass: 'Indtast adgangssætningen.',
  auth_restoring: 'Gendanner…',
  auth_file_prefix: 'Fil:',
  common_accept: 'Accepter',
  common_reject: 'Afvis',
  common_cancel: 'Annuller',
  common_accepting: 'Accepterer…',
  common_error: 'Fejl',
  common_loading: 'Indlæser…',
  common_send: 'Send',
  common_copied: 'Kopieret ✓',
  common_copy_failed: 'Kopiering mislykkedes',
  common_ok: 'OK',
  common_today: 'I dag',
  common_yesterday: 'I går',
  common_sending: 'Sender…',
  home_zn_midnight_hint: 'Skifter ved UTC midnat (om {h}t {m}m)',
  home_temp_empty: 'Ingen tidsbegrænsede chats. Tryk ⏱ på en kontakt for at starte en.',
  home_unread_aria: '{count} beskeder',
  home_temp_waiting: 'Venter på accept…',
  home_temp_expires: 'Tidsbegrænset chat · udløber om {remaining}',
  home_temp_cancel: 'Annuller',
  home_temp_fallback_label: 'tidsbegrænset chat',
  home_temp_invite_title: '⏱ Invitation til tidsbegrænset chat',
  home_temp_invite_body: '{nick} ønsker en midlertidig chat ({duration}).',
  home_temp_invite_hint: 'Accepter for at begynde at udveksle beskeder, der forsvinder ved udløb.',
  home_temp_accept: 'Accepter',
  home_temp_reject: 'Afvis',
  home_temp_accepting: 'Accepterer…',
  home_contacts_empty: 'Ingen kontakter. Del din ZN- kode eller QR for at parre.',
  home_temp_chat_aria: 'Tidsbegrænset chat',
  home_btn_pair_title: 'Par',
  home_btn_settings_title: 'Indstillinger',
  home_zn_title: 'Dagens ZN- kode',
  home_btn_copy_zn: 'Kopier ZN-',
  home_btn_open_pair: 'Parings-QR',
  home_section_temp: 'Tidsbegrænsede chats',
  home_section_chat: 'Chats',
  home_loading: 'Indlæser…',
  home_pair_zn_title: 'Par med ZN- kode',
  home_btn_zn_pair: 'Send anmodning',
  home_copied: 'Kopieret ✓',
  home_copy_failed: 'Kopiering mislykkedes',
  home_pair_request_title: 'Kontaktanmodning',
  home_pair_request_body: '{name} vil chatte.',
  home_pair_reject: 'Afvis',
  home_pair_accept: 'Accepter',
  home_pair_accepting: 'Accepterer…',
  home_pair_accept_failed: 'Accept mislykkedes',
  home_zn_digits_err: 'Indtast de 5 cifre efter ZN-.',
  home_sending: 'Sender…',
  chat_rename: 'Omdøb',
  chat_rename_matrix: '[OMDØB]',
  chat_rename_title: 'Omdøb kontakt',
  chat_menu_title: 'Chat-indstillinger',
  chat_loading: 'Indlæser beskeder…',
  chat_reply_to: 'Svar til',
  chat_cancel_title: 'Annuller',
  chat_voice_lock_hint: 'Stryg op for at låse optagelse',
  chat_voice_locked: 'Optagelse låst — tryk Færdig',
  chat_voice_stop: 'FÆRDIG',
  chat_voice_stop_title: 'Færdig',
  chat_voice_preview_label: 'Stemme-forhåndsvisning — lyt før du sender',
  chat_voice_send: 'SEND',
  chat_voice_send_title: 'Send',
  chat_timer_label: 'Timer',
  chat_timer_title: 'Besked-timer',
  chat_timer_off: 'FRA',
  chat_timer_15s: '15s',
  chat_timer_30s: '30s',
  chat_timer_1m: '1m',
  chat_timer_2m: '2m',
  chat_photo: 'Foto',
  chat_photo_title: 'Foto',
  chat_voice_hold: 'Hold for at optage',
  chat_voice_hold_title: 'Hold for at optage',
  chat_doc: 'Dok',
  chat_doc_title: 'Dokument',
  chat_attach_title: 'Vedhæftninger',
  chat_input_placeholder: 'E2E-krypteret besked…',
  chat_send: 'Send',
  chat_rename_modal_title: 'Omdøb kontakt',
  chat_rename_nickname: 'Kaldenavn: @{nick}',
  chat_rename_placeholder: 'Brugerdefineret navn',
  chat_rename_cancel: 'Annuller',
  chat_rename_save: 'Gem',
  chat_action_reply: '↩ Svar',
  chat_action_copy: '⎘ Kopier',
  chat_action_delete_me: '🗑 Slet for mig',
  chat_action_delete_all: '🗑 Slet for alle',
  chat_action_cancel: 'Annuller',
  chat_menu_clear_me: '🗑 Ryd chat (kun for mig)',
  chat_menu_clear_all: '🗑 Slet chat for alle',
  chat_menu_cancel: 'Annuller',
  chat_doc_send_title: 'Send dokument',
  chat_doc_default_name: 'dokument',
  chat_doc_send_hint: 'Filen komprimeres, E2E-krypteres og sendes. Maks. 5 MB.',
  chat_doc_cancel: 'Annuller',
  chat_doc_send_encrypted: 'Send krypteret',
  chat_doc_too_large: '⚠️ FIL FOR STOR: Den maksimale sikkerhedsgrænse for dokumenter er 5 MB.',
  chat_doc_unsupported: 'Dokumenttypen understøttes ikke.',
  chat_copy_failed: 'Kopiering mislykkedes',
  chat_confirm_delete_me: 'Slet denne besked kun for dig?',
  chat_confirm_delete_all: 'Slet denne besked for alle?',
  chat_confirm_clear_all: 'Slet hele chatten for alle? Denne handling kan ikke fortrydes.',
  chat_confirm_clear_me: 'Ryd chatten kun for dig?',
  chat_jump_new: '↓ Nye beskeder',
  chat_empty: 'Ingen beskeder. Skriv noget for at starte.',
  chat_voice_err_short: 'Talebesked for kort (minimum 1 sekund).',
  chat_voice_err_long: 'Talebesked for lang (maksimum 2 minutter).',
  chat_voice_err_large: 'Talebesked for stor (maks. 3 MB).',
  chat_voice_err_start: 'Stemmeoptagelse kunne ikke startes.',
  chat_destroyed: '✉ Besked læst og destrueret',
  chat_destroyed_title: 'Besked læst og destrueret',
  chat_hold_options: 'Hold for indstillinger',
  chat_reply_fallback: 'Besked',
  chat_timer_badge: '⏱ {seconds}s',
  chat_timer_badge_pending: '⏱ …',
  pair_zn_midnight_hint: 'ZN- koden skifter ved UTC midnat (om {h}t {m}m).',
  pair_copied: 'Kopieret ✓',
  pair_copy_failed: 'Kopiering mislykkedes',
  pair_title: 'Parings',
  pair_zn_title: 'Din ZN- kode i dag',
  pair_btn_copy_zn: 'Kopier ZN- kode',
  pair_tab_mine: 'Min QR',
  pair_tab_scan: 'Scan / ZN-',
  pair_qr_aria: 'Parings-QR',
  pair_expires_in: 'Udløber om',
  pair_btn_copy_payload: 'Kopier payload',
  pair_btn_regen_qr: 'Generer ny QR',
  pair_qr_hint: 'Vis denne QR til den anden enhed. Gyldig i 10 minutter — kompatibel med Android-appen.',
  pair_expired: 'udløbet',
  pair_contact_zn_title: 'Kontaktens ZN- kode',
  pair_zn_prefix_hint: 'Præfikset <strong>ZN-</strong> er allerede sat — indtast kun de 5 bogstaver/cifre.',
  pair_btn_zn_request: 'Send ZN- anmodning',
  pair_paste_title: 'Eller indsæt en ZION1:: QR',
  pair_paste_hint: 'Indsæt en <code>ZION1::</code> payload eller upload et foto af QR-koden.',
  pair_paste_placeholder: 'ZION1::…',
  pair_btn_pick_qr: 'Fra foto / kamera',
  pair_btn_connect_qr: 'Forbind med QR',
  pair_zn_digits_err: 'Indtast de 5 cifre efter ZN-.',
  pair_sending: 'Sender anmodning…',
  pair_reading_qr: 'Læser QR…',
  pair_qr_not_found: 'QR-kode ikke fundet i billedet.',
  pair_zn_read_ok: 'ZN- kode læst — bekræft med Send anmodning.',
  pair_qr_read_ok: 'QR læst — bekræft med Forbind med QR.',
  pair_qr_read_err: 'Fejl ved læsning af QR.',
  settings_identity_hint: 'Adgangskode og nøgler forbliver i denne browser. Ingen serverkonto.',
  settings_btn_add_home: 'Guide til Tilføj til startskærm',
  settings_devices_title: 'Tilknyttede enheder',
  settings_devices_hint: 'Multi-enhed Zero-Knowledge: nøgler sendes E2E-krypteret. Serveren er kun en relæ.',
  settings_btn_link_device: 'Tilknyt ny enhed',
  settings_btn_sync_pc: 'Synk PC-historik',
  settings_no_devices: 'Ingen tilknyttede enheder.',
  settings_device_self: 'denne enhed',
  settings_version_prefix: 'Version:',
  settings_ios_push_hint: '<strong>iPhone:</strong> notifikationer = PWA fra Hjem + Banner/Lyd TIL. Build ≥ <code>iospush7</code>.',
  settings_btn_force_update: 'Tving app-opdatering',
  settings_updating: 'Opdaterer…',
  settings_push_mode_prefix: 'Tilstand:',
  settings_push_hint_ios: '<strong>iPad/iPhone:</strong> notifikationer virker kun, når ZION åbnes fra ikonet på startskærmen (Del → Tilføj til startskærm). I almindelig Safari er de <em>ikke</em> tilgængelige — selv på iOS 17. Efter installation på startskærmen, vend tilbage hertil og tryk Aktiver notifikationer.',
  settings_btn_enable_push: 'Aktiver push-notifikationer',
  settings_btn_desktop_notify: 'Skrivebordsnotifikationer (PC)',
  settings_btn_disable_push: 'Deaktiver notifikationer',
  settings_desktop_requesting: 'Anmoder om skrivebordstilladelse…',
  settings_desktop_ok: 'Skrivebordsnotifikationer aktive (lyd + popup ved ny besked).',
  settings_desktop_denied: 'Tilladelse nægtet eller understøttes ikke.',
  settings_push_no_session: 'Sessionen er ikke klar.',
  settings_push_requesting: 'Anmoder om tilladelse…',
  settings_push_active: 'Notifikationer aktive.',
  settings_push_disabled: 'Notifikationer deaktiveret.',
  settings_theme_hint: 'Samme temaer som ZION Android-appen.',
  settings_theme_recommended: 'Anbefalet',
  settings_backup_hint: 'JSON-fil krypteret med adgangssætning (kompatibel med Android v2-format). Gem på din PC: kontakter, chats og webidentitet.',
  settings_backup_pass_label: 'Adgangssætning til sikkerhedskopi',
  settings_backup_pass_ph: 'Dedikeret adgangssætning (min. 8 tegn)',
  settings_btn_export_backup: 'Eksporter sikkerhedskopi',
  settings_backup_file_label: 'Gendan fra fil',
  settings_backup_import_pass_label: 'Adgangssætning til sikkerhedskopi',
  settings_backup_import_pass_ph: 'Adgangssætning brugt ved eksport',
  settings_btn_import_backup: 'Gendan sikkerhedskopi',
  settings_backup_file_prefix: 'Fil: {name}',
  settings_backup_pass_min: 'Adgangssætningen skal være mindst 8 tegn.',
  settings_backup_creating: 'Opretter sikkerhedskopi…',
  settings_backup_pick_file: 'Vælg en sikkerhedskopifil (.enc eller .enc.json).',
  settings_backup_need_pass: 'Indtast adgangssætningen til sikkerhedskopien.',
  settings_backup_restoring: 'Gendanner…',
  settings_backup_overwrite_confirm: 'Overskriv lokale data?',
  settings_modal_ok: 'OK',
  temp_duration_5m: '5 minutter',
  temp_duration_10m: '10 minutter',
  temp_duration_15m: '15 minutter',
  temp_duration_30m: '30 minutter',
  temp_duration_1h: '1 time',
  temp_duration_6h: '6 timer',
  temp_duration_24h: '24 timer',
  temp_duration_7d: '7 dage',
  temp_remaining_expired: 'Udløbet',
  temp_remaining_days: '{days}d {hours}t',
  temp_remaining_hours: '{hours}t {minutes}m',
  temp_remaining_minutes: '{minutes}m',
  temp_remaining_seconds: '{seconds}s',
  temp_screen_subtitle: 'Tidsbegrænset chat · midlertidige beskeder',
  temp_empty: 'Ingen midlertidige beskeder.',
  temp_empty_hint: 'Skriv en midlertidig besked. Den forsvinder, når timeren udløber.',
  temp_input_placeholder: 'Midlertidig besked…',
  temp_send: 'Send',
  temp_waiting_accept: 'Venter på at {name} accepterer den tidsbegrænsede chat…',
  temp_waiting_placeholder: 'Venter på accept…',
  temp_expires_in: 'Udløber om {remaining}',
  temp_duration_title: 'Tidsbegrænset chat',
  temp_duration_with: 'Med {name}',
  temp_duration_hint: 'Vælg varighed — chatten forsvinder fra begge enheder.',
  temp_sending_invite: 'Sender invitation…',
  voice_lock_hint: 'Stryg op for at låse optagelse',
  voice_locked: 'Optagelse låst — tryk Færdig',
  add_home_title: 'Tilføj til startskærm (iPhone / iPad)',
  add_home_guide_title: 'Safari-guide',
  add_home_step1: 'Åbn <strong>Safari</strong> på denne side (<code>zionyx.ch/app/</code>)',
  add_home_step2: 'Tryk på <strong>Del</strong> (firkant med pil opad)',
  add_home_step3: 'Vælg <strong>Tilføj til startskærm</strong>',
  add_home_step4: 'Åbn ZION fra <strong>ikonet</strong> — ikke fra en Safari-fane',
  add_home_hint: 'På iOS/iPadOS 16.4+ understøtter startskærmsappen Web Push-notifikationer og chat-tastaturet. Efter installation, gå til <strong>Indstillinger → Aktiver notifikationer</strong>.',
  add_home_btn_continue: 'Forstået — fortsæt',
  add_home_btn_skip: 'Spring over for nu',
  search_title: 'Søg med ZN- kode',
  search_label: 'Daglig ZN- kode',
  search_placeholder: 'ZN-123456',
  search_btn: 'Søg',
  search_hint: 'Indtast kontaktens ZN- kode. Ingen kaldenavnssøgning — identiteten er kun lokal.',
  search_format_err: 'Format: ZN-123456',
  search_resolving: 'Løser kode…',
  search_invalid_code: 'Ugyldig kode — bed om en opdateret ZN- (genåbn ZION på den anden persons enhed)',
  search_session_found: 'session fundet',
  search_tap_to_send: 'Tryk for at sende anmodning',
  search_socket_not_ready: 'Socket-sessionen er ikke klar',
  search_request_sent: 'Anmodning sendt ✓',
  search_request_failed: 'Afsendelse mislykkedes',
  license_title: 'Web- / iPhone-licensaktivering',
  license_heading: 'Licens',
  license_heading_updated: 'Opdaterede vilkår',
  license_hint: 'Indtast koden <strong>ZION-XXXX-XXXX-XXXX</strong> købt på zionyx.ch. Den knyttes til denne browser (lokal nøgle).',
  license_code_label: 'Licenskode',
  license_code_placeholder: 'ZION-XXXX-XXXX-XXXX',
  license_btn_activate: 'Aktiver licens',
  license_beta_hint: 'Web-beta: brug en dedikeret iPhone-licens, hvis tilgængelig.',
  license_accept_legal_err: 'Accepter privatliv og vilkår for at fortsætte',
  license_need_code: 'Indtast licenskoden',
  license_verifying: 'Verificerer licens…',
  license_invalid_or_used: 'Ugyldig licens eller allerede brugt på en anden enhed',
  license_active: 'Licens aktiv ✓',
  license_err_not_found: 'Ugyldig licenskode',
  license_err_conflict: 'Licens allerede knyttet til en anden enhed',
  license_err_rate_limit: 'For mange forsøg — vent et minut',
  license_err_generic: 'Licensfejl',
  link_device_title: 'Tilknyt ny enhed',
  link_device_hint: 'På din <strong>PC</strong>, åbn Indstillinger → Tilknyt ny enhed: du ser den <strong>grønne QR</strong>. Scan den nedenfor (kamera eller foto).',
  link_device_status_ready: '[KLAR]',
  link_device_upload_label: 'Upload QR-foto',
  link_device_btn_camera: 'Åbn kamera / galleri',
  link_device_placeholder: 'QR-link eller payload…',
  link_device_btn_send_vault: 'Send krypteret boks',
  link_device_err_invalid_qr: 'Ugyldig eller udløbet QR.',
  link_device_status_invalid: '[UGYLDIG QR]',
  link_device_status_sync_complete: '[SYNC FULDFØRT]',
  link_device_status_transfer_failed: '[OVERFØRSEL MISLYKKEDES]',
  link_device_status_qr_detected: '[QR REGISTRERET — OVERFØRER...]',
  link_device_status_tap_camera: '[TRYK PÅ DEN GRØNNE KNAP — IPHONE-KAMERA]',
  link_device_status_use_camera_below: '[BRUG KAMERA / GALLERI NEDENFOR]',
  link_device_status_point_camera: '[RET KAMERA MOD PC-QR...]',
  link_device_status_decoding: '[DEKODER QR...]',
  link_device_status_qr_not_found: '[QR IKKE FUNDET]',
  link_device_status_decode_failed: '[DEKODNING MISLYKKEDES]',
  link_device_status_opened_from_qr: '[ÅBNET FRA QR — STARTER...]',
  link_recv_title: 'Forbind fra telefon',
  link_recv_hint_compact:
    'Scan denne <strong>grønne QR</strong> med telefonen (Indstillinger → Forbind ny enhed). Vaulten er end-to-end-krypteret.',
  link_recv_hint_auth:
    'Har du allerede ZION på telefonen? Scan denne QR med <strong>Kamera</strong> — PC’en forbinder og logger ind automatisk.',
  link_recv_qr_alt: 'QR til enhedsforbindelse',
  link_recv_copy_link: 'Kopiér link',
  link_recv_awaiting: '[VENTER PÅ TELEFONSCAN — TUNNEL ÅBEN...]',
  link_recv_failed: '[PARRING MISLYKKEDES]',
  link_recv_tunnel_lost:
    'Tunnel afbrudt — vaulten kan stadig være undervejs. Prøv at scanne QR igen.',
  notify_title_prefix: 'ZION — {name}',
  notify_default_body: 'Ny krypteret besked',
  notify_temp_title_prefix: 'ZION ⏱ {name}',
  notify_temp_default_body: 'Midlertidig besked',
  force_update_title: '🚨 OBLIGATORISK KRITISK OPDATERING — For at fortsætte med at bruge Zionyx sikkert skal du downloade den nyeste version.',
  force_update_desc: 'Den installerede klient er ikke kompatibel med minimumsversionen, der er aktiv på serveren.',
  force_update_versions: 'Installeret: v{current} · Påkrævet: v{required}',
  force_update_btn: 'OPDATER NU',
}
